<template>
    <div class="card">
    <div class="card-header">
      <h5>Revenue Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
            <div class="row mt-3">
                <div class="col-md-12">
                <label for="tour" class="form-label">Tour Name</label> 
                    <v-select
                        :options="[
                            {
                                id: 0,
                                name:'All'
                            },
                            ...tours
                        ]"
                        label="name"
                        class="m-0"
                        id="tour"
                        index="id"
                        multiple
                        v-model="seletcedTours"
                    />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                <h6>Departure Date Range</h6>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-6">
                <dateTimePicker
                    no-label
                    label="From Date"
                    id="departureDateStart"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    v-model="departureDateStart.date"
                    button-color="#ec391e"
                    :only-date="true"
                    color="#ec391e"
                    style="border: 1px solid #DFE5F9"
                />
                <small class="text-danger" v-if="errors.departure_start">{{ errors.departure_start }}</small>
                </div>
                <div class="col-md-6">
                <dateTimePicker
                    no-label
                    label="To Date"
                    id="departureDateEnd"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    v-model="departureDateEnd.date"
                    button-color="#ec391e"
                    :only-date="true"
                    color="#ec391e"
                    style="border: 1px solid #DFE5F9"
                    :min-date="departureDateStart.date"
                />
                <small class="text-danger" v-if="errors.departuare_end">{{ errors.departuare_end }}</small>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button type="submit" class="button" v-on:click="generateRevenueReport">
        Generate report
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'RevenueReportFields',
    props:{
        tours: Array,
        reportVersion: {
            type: String,
            default: 'v1',
            required: true,
            validator: (value) => {
            return ['v1', 'v2'].includes(value);
            }
        }
    },
    data() {
        return {
            departureDateStart: {},
            departureDateEnd: {},
            selected_tours:[],
            errors: {
                departure_start:null,
                departuare_end: null,
                selected_tours:null
            },
        }  
    },
    computed: {
        seletcedTours : {
            get: function() {
                return this.selected_tours;
            },
            set: function (newValue) {
                if (newValue == 0) {
                    const ids = this.tours.map(obj => obj.id);
                    this.selected_tours = ids
                } else {
                    this.selected_tours = newValue
                }
            }
        },
    },
    methods: {
        validateFields()
        {
            let This = this

            return new Promise((resolve, reject) => {

                let errorCount = 0;

                // Departure Dates validation
                if(This.departureDateStart.date && !This.departureDateEnd.date) {
                    This.errors.departuare_end = "Please select a valid departure to date"
                    errorCount +=1
                }else if(This.departureDateEnd.date && !This.departureDateStart.date){
                    This.errors.departure_start = "Please select a valid departure from date"
                    errorCount +=1
                }else{
                    This.errors.departuare_end = null
                    This.errors.departure_start = null
                }

                // Tour Selected 
                if (This.selected_tours.length == 0) {
                    This.errors.selected_tours = "Please select atleast one tour"
                    errorCount +=1
                } else{
                    This.errors.selected_tours = null
                }

                if(errorCount == 0 ){
                    resolve(true)
                }else{
                    reject(true)
                }

            })
        },
        generateRevenueReport () {
            this.validateFields()
                .then((response) => {
                    if (response) {
                        this.$store.dispatch("setLoadStatus");
                        let url = (this.reportVersion == 'v2') ? this.$api + 'reports/v2/generate-revenue-report' : this.$api + 'reports/revenue-report';
                        axios({
                            method:'post',
                            url,
                            responseType:'arraybuffer',
                            data: {
                                departureDateStart: this.departureDateStart.date,
                                departureDateEnd: this.departureDateEnd.date,
                                selected_tours: this.selected_tours,
                            },
                            headers: {
                                'Content-Type':'application/json',
                                'Accept': 'application/json',
                                'Authorization': localStorage.getItem('token')          
                            }
                        })
                        .then((response) => {
                            this.$store.dispatch('setLoadStatus')
                            let blob = new Blob([response.data], { type:'application/xlsx' } );
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = 'Revenue-Report.xlsx';
                            link.click();
                        })
                        .catch((error) =>{
                            this.$store.dispatch('setLoadStatus')
                            this.$notify({
                                type: 'error',
                                title: "The given data was invalid."
                            });
                        }).finally(() => {
                            // this.$store.dispatch('setLoadStatus')
                        });
                    }
                })
        },
    }
}
</script>
